const code = {
    "0X01M01": "账号重复",
    "0X01M02": "账号或密码错误",
    "0X01M03": "验证码过期",
    "0X01M04": "验证码异常",
    "0X02M01": "企业已存在",
    "0XpthrmM01": "企业已存在",
    "0XpthrmM02": "部门在使用不可删除",
    "0XpthrmM03": "岗位在使用不可删除",
    "0XpthrmM04": "部门已存在",
    "0XpthrmM05": "岗位已存在",
    "0XpthrmM06": "角色已存在",
    "0XpthrmM07": "上级部门未找到",
    "0XpthrmM08": "账号未绑定微信",
    "0XpturpM01": "不可删除",
    "400":"参数解析失败",
    "0X01M05":"原密码错误"
};
module.exports = code;
